export enum PreferredContact {
  EMAIL = 'email',
  PHONE = 'telephone'
}
